import { createBrowserRouter, Navigate } from 'react-router-dom';
import PublicLayout from '../layouts/PublicLayout';
import AdminLayout from '../layouts/AdminLayout';
import HomePage from '../pages/public/HomePage';
import FormationsPage from '../pages/public/FormationsPage';
import TrainingCatalogPage from '../pages/public/TrainingCatalogPage';
import ProtectedRoute from '../components/ProtectedRoute';
import AuthPage from '../pages/auth/AuthPage';
import RoleSelectionPage from '../pages/auth/RoleSelectionPage';
import UserAuthPage from '../pages/auth/UserAuthPage';
import TrainingCenterAuthPage from '../pages/auth/TrainingCenterAuthPage';
import TrainingCenterCompleteProfilePage from '../pages/auth/TrainingCenterCompleteProfilePage';
import EmailVerificationPage from '../pages/auth/EmailVerificationPage';
import ForgotPasswordPage from '../pages/auth/ForgotPasswordPage';
import ResetPasswordPage from '../pages/auth/ResetPasswordPage';
import CompleteProfilePage from '../pages/training-center/CompleteProfilePage';
import TrainingCenterDashboardPage from '../pages/training-center/TrainingCenterDashboardPage';
import TraineeDashboardPage from '../pages/trainee/TraineeDashboardPage';
import TrainingCenterEditProfilePage from '../pages/training-center/EditProfilePage';
import TrainingsPage from '../pages/training-center/TrainingsPage';
import CreateTrainingPage from '../pages/training-center/CreateTrainingPage';
import ViewTrainingPage from '../pages/training-center/ViewTrainingPage';
import EditTrainingPage from '../pages/training-center/EditTrainingPage';
import TrainingDetailPage from '../pages/public/TrainingDetailPage';
import PublicTrainingCentersPage from '../pages/public/TrainingCentersPage';
import TrainingCenterDetailPage from '../pages/public/TrainingCenterDetailPage';
import ConsultantsPage from '../pages/public/ConsultantsPage';
import ConsultantDetailPage from '../pages/public/ConsultantDetailPage';
import ServiceDetailPage from '../pages/public/ServiceDetailPage';
import CreneauxReservationPage from '../pages/public/CreneauxReservationPage';
import ConsultantAuthPage from '../pages/auth/ConsultantAuthPage';
import ConsultantCompleteProfilePage from '../pages/auth/ConsultantCompleteProfilePage';
import ConsultantDashboardPage from '../pages/consultant/ConsultantDashboardPage';
import CreateServicePage from '../pages/consultant/CreateServicePage';
import CreneauxManagementPage from '../pages/consultant/CreneauxManagementPage';
import ServicesPage from '../pages/consultant/ServicesPage';
import EditServicePage from '../pages/consultant/EditServicePage';
import ViewServicePage from '../pages/consultant/ViewServicePage';
import ConsultantStatsPage from '../pages/consultant/StatsPage';
import ClientsPage from '../pages/consultant/ClientsPage';
import ConsultantCalendarPage from '../pages/consultant/CalendarPage';
import ConsultantInvoicesPage from '../pages/consultant/InvoicesPage';
import ConsultantProfilePage from '../pages/consultant/ProfilePage';
import ConsultantSubscriptionsPage from '../pages/consultant/SubscriptionsPage';
import FaqPage from '../pages/public/FaqPage';

// Trainee pages
import CatalogPage from '../pages/trainee/CatalogPage';
import MyTrainingsPage from '../pages/trainee/MyTrainingsPage';
import ProfilePage from '../pages/trainee/ProfilePage';
import TrainingSubscriptionPage from '../pages/trainee/TrainingSubscriptionPage';

// Training center pages
import ParticipantsPage from '../pages/training-center/ParticipantsPage';
import CalendarPage from '../pages/training-center/CalendarPage';
import ConsultantLayout from '../layouts/ConsultantLayout';
import TrainingCenterLayout from '../layouts/TrainingCenterLayout';
import TrainingCenterSubscriptionsPage from '../pages/training-center/SubscriptionsPage';
import TrainingCenterInvoicesPage from '../pages/training-center/InvoicesPage';
import StatsPage from '../pages/training-center/StatsPage';

// Admin pages
import AdminDashboardPage from '../pages/admin/AdminDashboardPage';
import UsersPage from '../pages/admin/UsersPage';
import TrainingCentersPage from '../pages/admin/TrainingCentersPage';
import AdminTrainingsPage from '../pages/admin/TrainingsPage';
import DataManagementPage from '../pages/admin/DataManagementPage';
import AdminSubscriptionsPage from '../pages/admin/SubscriptionsPage';
import InvoicesPage from '../pages/admin/InvoicesPage';
import ReportsPage from '../pages/admin/ReportsPage';
import ModerationPage from '../pages/admin/ModerationPage';
import PrestationsPage from '../pages/admin/PrestationsPage';
import SettingsPage from '../pages/admin/SettingsPage';
import TrainingCenterProfilePage from '../pages/training-center/ProfilePage';
import AdminConsultantsPage from '../pages/admin/ConsultantsPage';
import SliderManagementPage from '../pages/admin/SliderManagementPage';

export const router = createBrowserRouter([
  {
    path: '/',
    element: <PublicLayout />,
    children: [
      {
        index: true,
        element: <HomePage />,
      },
      {
        path: 'formations',
        element: <FormationsPage />,
      },
      {
        path: 'trainings',
        element: <TrainingCatalogPage />,
      },
      {
        path: 'trainings/all',
        element: <TrainingCatalogPage />,
      },
      {
        path: 'training/:id',
        element: <TrainingDetailPage />,
      },
      {
        path: 'centers',
        element: <PublicTrainingCentersPage />,
      },
      {
        path: 'consultants',
        element: <ConsultantsPage />,
      },
      {
        path: 'training-center/:id',
        element: <TrainingCenterDetailPage />,
      },
      {
        path: 'consultant/:id',
        element: <ConsultantDetailPage />,
      },
      {
        path: 'service/:id',
        element: <ServiceDetailPage />,
      },
      {
        path: 'consultant/:id/service/:serviceId/reserve',
        element: <CreneauxReservationPage />,
      },
      {
        path: 'faq',
        element: <FaqPage />,
      },
    ],
  },
  {
    path: '/auth',
    children: [
      {
        index: true,
        element: <AuthPage />,
      },
      {
        path: 'role-selection',
        element: <RoleSelectionPage />,
      },
      {
        path: 'user',
        element: <UserAuthPage />,
      },
      {
        path: 'training-center',
        element: <TrainingCenterAuthPage />,
      },
      {
        path: 'training-center/complete-profile',
        element: <TrainingCenterCompleteProfilePage />,
      },
      {
        path: 'consultant',
        element: <ConsultantAuthPage />,
      },
      {
        path: 'consultant/complete-profile',
        element: <ConsultantCompleteProfilePage />,
      },
      {
        path: 'verify-email',
        element: <EmailVerificationPage />,
      },
      {
        path: 'forgot-password',
        element: <ForgotPasswordPage />,
      },
      {
        path: 'reset-password',
        element: <ResetPasswordPage />,
      },
    ],
  },
  {
    path: '/training-center',
    element: <ProtectedRoute requiredRole="training_center"><TrainingCenterLayout /></ProtectedRoute>,
    children: [
      {
        path: 'dashboard',
        element: <TrainingCenterDashboardPage />,
      },
      {
        path: 'stats',
        element: <StatsPage />,
      },
      {
        path: 'profile',
        element: <TrainingCenterProfilePage />,
      },
      {
        path: 'edit-profile',
        element: <TrainingCenterEditProfilePage />,
      },
      {
        path: 'profile/complete',
        element: <CompleteProfilePage />,
      },
      {
        path: 'trainings',
        element: <TrainingsPage />,
      },
      {
        path: 'trainings/create',
        element: <CreateTrainingPage />,
      },
      {
        path: 'trainings/:id',
        element: <ViewTrainingPage />,
      },
      {
        path: 'trainings/:id/edit',
        element: <EditTrainingPage />,
      },
      {
        path: 'participants',
        element: <ParticipantsPage />,
      },
      {
        path: 'calendar',
        element: <CalendarPage />,
      },
      {
        path: 'subscriptions',
        element: <TrainingCenterSubscriptionsPage />,
      },
      {
        path: 'invoices',
        element: <TrainingCenterInvoicesPage />,
      },
      {
        path: 'sessions',
        element: <Navigate to="/training-center/participants" replace />,
      },
    ],
  },
  // Consultant routes
  {
    path: '/consultant',
    element: <ProtectedRoute requiredRole="consultant"><ConsultantLayout /></ProtectedRoute>,
    children: [
      {
        index: true,
        element: <ConsultantDashboardPage />,
      },
      {
        path: 'dashboard',
        element: <ConsultantDashboardPage />,
      },
      {
        path: 'services',
        element: <ServicesPage />,
      },
      {
        path: 'services/create',
        element: <CreateServicePage />,
      },
      {
        path: 'services/:id',
        element: <ViewServicePage />,
      },
      {
        path: 'services/:id/edit',
        element: <EditServicePage />,
      },
      {
        path: 'services/:id/creneaux',
        element: <CreneauxManagementPage />,
      },
      {
        path: 'clients',
        element: <ClientsPage />,
      },
      {
        path: 'calendar',
        element: <ConsultantCalendarPage />,
      },
      {
        path: 'stats',
        element: <ConsultantStatsPage />,
      },
      {
        path: 'invoices',
        element: <ConsultantInvoicesPage />,
      },
      {
        path: 'profile',
        element: <ConsultantProfilePage />,
      },
      {
        path: 'subscriptions',
        element: <ConsultantSubscriptionsPage />,
      },
    ],
  },
  {
    path: '/dashboard',
    element: <ProtectedRoute requiredRole="trainee"><TraineeDashboardPage /></ProtectedRoute>,
  },
  // Trainee routes
  {
    path: '/catalog',
    element: <ProtectedRoute requiredRole="trainee"><CatalogPage /></ProtectedRoute>,
  },
  {
    path: '/my-trainings',
    element: <ProtectedRoute requiredRole="trainee"><MyTrainingsPage /></ProtectedRoute>,
  },
  {
    path: '/profile',
    element: <ProtectedRoute requiredRole="trainee"><ProfilePage /></ProtectedRoute>,
  },
  {
    path: '/training-subscription/:trainingId',
    element: <ProtectedRoute requiredRole="trainee"><TrainingSubscriptionPage /></ProtectedRoute>,
  },
  // Admin routes
  {
    path: '/admin',
    element: <ProtectedRoute requiredRole="admin"><AdminLayout /></ProtectedRoute>,
    children: [
      {
        index: true,
        element: <Navigate to="/admin/dashboard" replace />,
      },
      {
        path: 'dashboard',
        element: <AdminDashboardPage />,
      },
      {
        path: 'users',
        element: <UsersPage />,
      },
      {
        path: 'training-centers',
        element: <TrainingCentersPage />,
      },
      {
        path: 'consultants',
        element: <AdminConsultantsPage />,
      },
      {
        path: 'trainings',
        element: <AdminTrainingsPage />,
      },
      {
        path: 'prestations',
        element: <PrestationsPage />,
      },
      {
        path: 'data-management',
        element: <DataManagementPage />,
      },
      {
        path: 'subscriptions',
        element: <AdminSubscriptionsPage />,
      },
      {
        path: 'invoices',
        element: <InvoicesPage />,
      },
      {
        path: 'reports',
        element: <ReportsPage />,
      },
      {
        path: 'moderation',
        element: <ModerationPage />,
      },
      {
        path: 'settings',
        element: <SettingsPage />,
      },
      {
        path: 'sliders',
        element: <SliderManagementPage />,
      },
    ],
  },
]); 